/**
 * Utilitários para Anonimização de Dados do Sistema
 * Regras idênticas ao apex-clientes:
 * 1. Nome: Mantém a 1ª letra de cada palavra, substituindo as demais por '*'
 * 2. E-mail: Mantém 1ª e última letra antes do '@' (substituindo o meio por '*'), e 1ª e última letra após o '@' (substituindo o meio por '*')
 * 3. Documento (CNPJ, CPF, etc): Exibe apenas os 2 primeiros números do documento, ocultando os demais com '*'
 * 4. Código: Substitui todos os caracteres/dígitos do código por '*'
 */

export const anonimizarNome = (nome) => {
    if (!nome || typeof nome !== 'string') return nome || '';
    return nome.split(' ').map(palavra => {
        if (!palavra) return '';
        const primeiraLetra = palavra.charAt(0);
        const restante = '*'.repeat(Math.max(0, palavra.length - 1));
        return primeiraLetra + restante;
    }).join(' ');
};

export const anonimizarEmail = (email) => {
    if (!email || typeof email !== 'string' || !email.includes('@')) {
        if (!email) return '';
        return email.charAt(0) + '*'.repeat(Math.max(0, email.length - 1));
    }

    const partes = email.split('@');
    const usuario = partes[0];
    const dominio = partes.slice(1).join('@');

    let usuarioAnon = usuario;
    if (usuario.length > 2) {
        usuarioAnon = usuario.charAt(0) + '*'.repeat(usuario.length - 2) + usuario.charAt(usuario.length - 1);
    } else if (usuario.length === 2) {
        usuarioAnon = usuario.charAt(0) + '*';
    } else if (usuario.length === 1) {
        usuarioAnon = '*';
    }

    let dominioAnon = dominio;
    if (dominio.length > 2) {
        dominioAnon = dominio.charAt(0) + '*'.repeat(dominio.length - 2) + dominio.charAt(dominio.length - 1);
    } else if (dominio.length === 2) {
        dominioAnon = dominio.charAt(0) + '*';
    } else if (dominio.length === 1) {
        dominioAnon = '*';
    }

    return `${usuarioAnon}@${dominioAnon}`;
};

export const anonimizarDocumento = (doc) => {
    if (!doc || typeof doc !== 'string') return doc || '';
    let digitosVistos = 0;
    let resultado = '';

    for (let i = 0; i < doc.length; i++) {
        const char = doc.charAt(i);
        if (/\d/.test(char)) {
            digitosVistos++;
            if (digitosVistos <= 2) {
                resultado += char;
            } else {
                resultado += '*';
            }
        } else {
            resultado += char;
        }
    }

    return resultado;
};

export const anonimizarCodigo = (codigo) => {
    if (codigo === undefined || codigo === null) return '';
    const str = String(codigo);
    return '*'.repeat(str.length);
};

export const anonimizarCampo = (valor, tipo = 'texto') => {
    if (valor === undefined || valor === null || valor === '') return valor;
    
    switch (tipo) {
        case 'nome':
            return anonimizarNome(String(valor));
        case 'email':
            return anonimizarEmail(String(valor));
        case 'documento':
        case 'cpf':
        case 'cnpj':
            return anonimizarDocumento(String(valor));
        case 'codigo':
            return anonimizarCodigo(valor);
        default:
            return anonimizarNome(String(valor));
    }
};

export const anonimizarCanal = (valor, tipo = '') => {
    if (!valor || typeof valor !== 'string') return valor || '';
    const t = String(tipo || '').toLowerCase();
    if (t.includes('mail') || valor.includes('@')) {
        return anonimizarEmail(valor);
    }
    return anonimizarDocumento(valor);
};
